export default "__VITE_ASSET__jIw5EoII__"